<template>
  <div>
    <div class="inqueryResult clearfix">
      <label class="title-line"></label>
      <span class="title">提现</span>
    </div>
    <el-card class="box-card" style="height: 450px; margin-top: 20px;">
      <el-form label-width="140px">
        <el-row>
          <el-form-item label="市场：">
            <span>{{ transferData.marketName }}</span>
          </el-form-item>
          <el-form-item label="付款账号：">
            <span>{{$key.keyFilter(transferData.channelCode, 'myAccount', 'bankName').name}} ({{exAccountNo(transferData)}})</span>
          </el-form-item>
          <el-form-item label="提现至：">
            <el-select v-model="form.payerBankCardNum" placeholder="请选择" filterable>
              <el-option v-for="item in accountList" :key="item.id" :label="item.bankName +' '+ item.bankNo" :value="item.bankNo"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="可提现金额：">
            <span style="color: #ff5255;">
              {{ withdrawableAmount }} 元
            </span>
          </el-form-item>
          <el-form-item label="提现金额：">
            <el-input class="input" v-model="form.applyAmount" clearable placeholder="请输入金额" @blur="checkType(form.applyAmount)"></el-input>
            <span class='amount'>元</span>
          </el-form-item>
          <div style="margin-left: 140px;">
            <el-button @click="cancel">取消</el-button>
            <el-button class="sure" @click="sure">确认提现</el-button>
          </div>
        </el-row>
      </el-form>
    </el-card>
    <el-dialog :title="passwordHidden ? '请输入支付密码' : '提现申请'" :visible.sync="dialogVisible" width="450px" :before-close="close" :close-on-click-modal="false">
      <div class="link-top"></div>
      <el-form :inline="true" label-width="100px" class="center">
        <div v-if="passwordHidden">
          <el-row style="width: 400px;">
            <el-form-item label="" style="margin-left: 100px;">
              <el-input v-model='password' :type="isDesen ? 'password' : ''" placeholder='请输入6位支付密码' class="input" @input="checkPass(password, 'password')"></el-input>
              <div @click="select" class="tips">
                <img src="@/assets/password_hide.png" alt="" class="password" v-if="isDesen">
                <img src="@/assets/password_visual.png" alt="" class="password" v-if="!isDesen">
              </div>
            </el-form-item>
            <el-button class="sureTx" @click="sureTransfer" :loading="loading" style="width: 230px;">确认提现</el-button>
            <div class="btn">
              <span class="left" @click="cancel">取消提现</span>
              <span class="right" @click="forgetPass">忘记密码?</span>
            </div>
          </el-row>
        </div>
        <div style="text-align: center" v-else>
          <img :src="success" alt="">
          <div class='passSuss'>提现成功</div>
          <el-button class="sure-l" @click="cancel">确定</el-button>
        </div>
      </el-form>
    </el-dialog>
    <forget-pass @closeMain="closeMain" v-if="isDisplay" editType='2'></forget-pass>
    <set-pass @closeMain="closeMain" v-if="isSetDisplay" :userId="userId"></set-pass>
  </div>
</template>

<script>
import Cookie from 'js-cookie'
import api from '@/api'
import CryptoJS from 'crypto-js'
import success from '@/assets/success.png'
import forgetPass from '@/components/forget-pass'
import setPass from '@/components/set-pass'
export default {
  name: 'fs-withdrawal',
  components: {
    forgetPass,
    setPass
  },
  props: {
    transferData: {
      type: Object
    },
  },
  data () {
    return {
      loading: false,
      success: success,
      withAmount: '',
      withAmountNew: '',

      dialogVisible: false,
      passwordHidden: true,
      password: '',

      isDisplay: false,
      isSetDisplay: false,
      // 金额校验
      reg: /^\d+(\.\d{2})?$/,
      // 密码脱敏显示
      isDesen: true,
      // 用户id
      userId: Cookie.getJSON('AppUserInfo').userId,
      // 校验规则
      companyRules: [
        { name: 'payerBankCardNum', message: '请选择提现卡号' },
        { name: 'payerBaseAccountNo', message: '请输入付款账号' },
        { name: 'applyAmount', message: '请输入提现金额' },
      ],
      // 提交表单数据
      form: {
        businessType: '203', // 203 提现 301转账
        channelCode: this.transferData.channelCode,
        applyAmount: '', // 申请金额
        password: '', // 密码
        payerBaseAccountNo: this.transferData.baseAccountNo, // 付款账户号
        payerBankCardNum: '', // 提现银行卡号
      },
      // 可提现金额
      withdrawableAmount: '',
      accountList: [], // 可提现银行卡号
    }
  },
  mounted () {
    api.myAccount.querySubBankAccountInfo().then(res => { // 查询附属账户
      this.fetchList() // 拉取可提现银行卡
      if (res.data.marketId !== '000') {
        this.baseAccountBalance(this.transferData.baseAccountNo)
      } else { // 白糖市场查询余额用恒生接口
        api.myAccount.querySubBankAccountBalance({
          bankProCode: res.data.bankProCode,
          subBankAccount: res.data.subBankAccount
        }).then((result) => {
          this.withdrawableAmount = result.data.canUseBalance // 拿到账户余额
        })
      }
    })
  },
  methods: {
    // 表单校验
    sure () {
      if (this.$utils.checkEmptyRules(this.form, this.companyRules)) {
        return false
      }
      if (this.form.applyAmount > this.withdrawableAmount) {
        this.$message.error('提现金额不能大于可划转金额')
        return false
      }
      // 通过校验-输入密码
      this.dialogVisible = true
    },
    // 密码验证
    async sureTransfer () {
      this.form.password = this.encryptByAes(this.password)
      if (this.userId) {
        const data = (await api.myAccount.checkHasPsw({ userId: this.userId })).data
        if (data === '1') {
          if (this.password === '') {
            this.$message.error('请输入支付密码')
            return false
          }
          this.loading = true
          api.myAccount.applyTransferOrWithdraw(this.form).then((res) => {
            this.$message.success('成功')
            this.passwordHidden = false
            this.loading = false
          })
        }
        if (data === '0') {
          this.$confirm('您还没有设置交易密码, 是否设置?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.isSetDisplay = true
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消设置'
            })
          })
        }
      }
    },
    // 获取列表数据
    fetchList (currentNo, pageSize) {
      let param = {
        pageNumber: 1,
        pageSize: 10
      }
      api.bankCard.getBankCardList(param).then((res) => {
        if (res.data) {
          this.accountList = res.data.rows
        }
      })
    },
    // // 获取货款信息列表
    // queryGoodsAccountInfo () {
    //   api.myAccount.queryGoodsAccountInfo({
    //     marketId: '000'
    //   }).then((res) => {
    //     if (res.succeed) {
    //       this.accountList = res.data
    //     } else {
    //       this.$message.error('请求失败')
    //     }
    //   })
    // },
    // 密码加密
    encryptByAes (psw) {
      let key = CryptoJS.enc.Utf8.parse('APP7apecSQznwPWD') // 秘钥
      let iv = CryptoJS.enc.Utf8.parse('307znw65426apecb') // 偏移量
      let srcs = CryptoJS.enc.Utf8.parse(psw)
      var encrypted = CryptoJS.AES.encrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 })
      return encrypted.ciphertext.toString().toUpperCase()
    },
    // 提现账户
    exAccountNo (row) {
      let baseAcc = row.exAccountNo.replace(/^([a-zA-Z0-9]{4})\d+(\d{4})$/, '$1 **** $2')
      return baseAcc
    },
    // 查询可提现金额
    async baseAccountBalance (baseAccountNo) {
      const data = (await api.myAccount.baseAccountBalance(JSON.stringify(baseAccountNo))).data
      this.withdrawableAmount = data.withdrawableAmount
    },
    // 密码脱敏显示
    select () {
      this.isDesen = !this.isDesen
    },
    // 金额校验
    checkType (v) {
      if (v < 0) {
        this.$message.error('提现金额不能小于0')
        this.form.applyAmount = ''
      }
    },
    // 关闭弹窗
    handleClose () {
      this.$emit('done')
    },

    // 关闭忘记密码弹窗
    close () {
      this.dialogVisible = false
    },
    // 取消提现
    cancel () {
      this.$emit('done', true)
    },
    // 忘记密码
    forgetPass () {
      this.isDisplay = true
    },
    closeMain (e) {
      this.isDisplay = false
      this.isSetDisplay = false
    },
    // 判断是否是数字
    checkPass (v, k) {
      if (!isNaN(v)) {
        this[k] = v
      } else {
        this[k] = ''
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.password {
  width: 22px;
  height: 10px;
  float: left;
}
.tips {
  position: absolute;
  top: 16px;
  left: 198px;
  width: 25px;
  height: 25px;
}
.el-form-item {
  margin-bottom: 8px;
}
.inqueryResult{
  margin-top: 15px; // 与表格的margin保持一致
  height: 32px;
  line-height: 32px;
  .title-line {
    width:4px;
    height:14px;
    background-color:#f8bd47;
    display:inline-block
  }
  .title {
    margin-left: 10px;
    font-size: 16px;
    font-weight: 600;
    color: #161616;
  }
}
.gobal-form{
  .el-input, .el-input__inner{
    width:217px !important;
  }
  div.input-val{
    display:inline-block;
    width:217px;
  }
}
.input {
  width: 230px;
  height: 32px;
  line-height: 32px;
}
.amount {
  margin-left: 10px;
  color: #666666;
}
.card {
  width: 230px;
	height: 40px;
	background-color: #fafcfe;
  border: solid 1px #8cb5de;
  cursor:pointer;
  .radius {
    width: 12px;
    height:12px;
    border: 4px solid #409EFF;
    border-radius: 50%;
    margin: 12px 15px 0 15px;
    float: left;
  }
  .bank {
    width: 85px;
    height: 16px;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #333;
    margin-top: -2px;
    font-weight: 600;
    float: left;
  }
  .number {
    width: 64px;
    height: 16px;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 16px;
    letter-spacing: 0px;
    color: #666666;
    margin-top: 10px;
    float: right;
    margin-right: 10px;
  }
}
.sure {
  margin: 20px 0 0 140px;
  // width: 160px;
  background: #f8bd47;
  color: #fff;
  border: none;
}
.sure-l {
  width: 260px;
  background: #f8bd47;
  color: #fff;
  margin-top: 40px;
}
.sureTx {
  margin: 20px 0 0 100px;
  width: 160px;
  background: #f8bd47;
  color: #fff;
  border: none;
}
.link-top {
  width: 100%;
  height: 1px;
  border-top: solid #f8bd47 1px;
  margin-bottom: 30px;
}
.btn {
  width: 55%;
  margin-left: 27%;
  margin-top: 30px;
  span {
    color: #5ca7ff;
    cursor:pointer;
  }
  .left {
    float: left;
  }
  .right {
    float: right;
  }
}
.passSuss {
  font-size: 14px;
  color: rgba(51, 51, 51, 0.94);
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  font-family: '微软雅黑';
  margin-top: 20px;
}
</style>
